import { useState } from "react";
import { FieldProps } from "./types";
import { FormContainer } from "./FormContainer";
import { FieldLabel, NumberInput } from "@braze/beacon-core";


export const RequiredNumber = (props: FieldProps) => {
    const [invalid, setInvalid] = useState(true);
    return (
        <FormContainer>
            <FieldLabel label={props.name} status={invalid ? "danger":"success"} statusText={props.name+" is required"}>
                <NumberInput 
                    fullWidth
                    name={props.name}
                    invalid={invalid}

                    onKeyDown={(e) => {
                        // Allow only numeric keys, navigation keys, and functional keys
                        const validKeys = [
                            '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', // Numbers
                            'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', // Navigation
                            'Home', 'End', 'Enter' // Navigation
                        ];
                        
                        if (!validKeys.includes(e.key) && !e.ctrlKey && !e.metaKey) {
                            e.preventDefault();
                        }
                    }}
                    onPaste={(e) => {
                        // Get pasted content
                        const pastedText = e.clipboardData.getData('text');
                        // Check if it contains decimals or non-numeric characters
                        if (!/^\d+$/.test(pastedText)) {
                            e.preventDefault();
                        }
                    }}
                    onChange={(e) => {
                        // Get current value
                        let inputValue = e.target.value;
                        
                        // Remove any non-numeric characters that might have gotten through
                        inputValue = inputValue.replace(/[^\d]/g, '');
                        
                        // Parse as integer
                        const value = inputValue ? Number.parseInt(inputValue, 10) : '';
                        
                        if (!value && value !== 0) {
                            props.handleChange('');
                            setInvalid(true);
                        } else {
                            setInvalid(false);
                            props.handleChange(value);
                        }
                    }}/>
            </FieldLabel>
        </FormContainer>
    )
}